export default "__VITE_ASSET__mizbj1_1__"